import React from "react";
import { useNavigate } from "react-router-dom";
import "./Terms.css"; // Shared legal UI styling

const Refund = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="glass-background"></div>

      {/* ⭐ NAVBAR WITH LOGO */}
      <nav className="legal-nav">
        <div className="nav-brand" onClick={() => navigate("/")}>
          <img src="/icons/logo-512.png" className="nav-logo" alt="GrammAA" />
          <span className="brand-text">GrammAA</span>
        </div>
      </nav>

      {/* ⭐ CONTENT */}
      <div className="legal-content glass-panel fade-in">
        <h1>Refund Policy</h1>
        <p className="updated-date">Last updated: {new Date().getFullYear()}</p>

        <p>
          Thank you for choosing <strong>GrammAA</strong>. This Refund Policy
          explains our rules regarding subscription payments and refund requests.
        </p>

        <h2>1. General Policy</h2>
        <p>
          Since GrammAA provides instant and automated AI processing services,
          subscription fees are generally <strong>non-refundable</strong> once the service
          has been activated for your account.
        </p>

        <h2>2. 24-Hour Refund Window</h2>
        <p>
          A refund may be granted only if:
        </p>
        <ul>
          <li>The purchase was made within the last 24 hours.</li>
          <li>No significant usage of the service has occurred.</li>
          <li>There is a genuine billing or activation issue.</li>
        </ul>

        <h2>3. Non-Refundable Situations</h2>
        <p>Refunds will <strong>not</strong> be provided in the following cases:</p>
        <ul>
          <li>You used the AI grammar checker or rewriting tools after subscribing.</li>
          <li>You changed your mind after purchase.</li>
          <li>You forgot to cancel the plan before renewal.</li>
          <li>Account misuse or violation of our Terms & Conditions.</li>
        </ul>

        <h2>4. Duplicate or Incorrect Payments</h2>
        <p>
          If you are charged twice or encounter a technical billing error,
          contact us and we will verify and issue a refund when applicable.
        </p>

        <h2>5. Payment Processing Time</h2>
        <p>
          Approved refunds may take <strong>5–7 business days</strong> to appear in your bank
          or card statement depending on your payment provider (Razorpay ).
        </p>

        <h2>6. Subscription Cancellation</h2>
        <p>
          You may cancel your active subscription at any time.  
          Cancellation stops future renewals, but previously paid fees remain non-refundable.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          For refund questions or billing issues, contact us at:
          <br />
          <strong>support@aiwebaa.com</strong>
        </p>

        <br />
        <p>We appreciate your trust in GrammAA.</p>
      </div>
    </div>
  );
};

export default Refund;
